module.exports = __webpack_public_path__ + "img/11.496d1526.jpg";